import React from 'react'
import Call from '../../components/Call/Call'

function CallPage() {
  return (
    <>
    <Call/>
    </>
  )
}

export default CallPage